import React, {useState} from "react";
import { Table} from "antd";
import {
	computeRowsAndColsForTeamPage
} from "../../../pages/chargers/utils/functions";
import { useNavigate } from "react-router-dom"; 
import { Transactions } from "pages/transactions/Transactions";
import useWindowDimensions from "common/functions";

interface ITable {
	data: Transactions
	selectedFilter?: string;
	setNewSort: (value: string) => void;
	shouldReset: (value: boolean) => void;
	reset: boolean;
	offset: number;
	setOffset: (value: number) => void;
	limit: number;
	length: number;
	setTransactions: (value: Transactions) => void;
	setReset: (value: boolean) => void;
	transactions: Transactions,
	setRefundParams: any;
	setIsModalOpen: (value: boolean) => void;
	setRecord: (value: any) => void;
    setEditOpen: (value: boolean) => void;
    setDeleteModelOpen: (value: boolean) => void;
}

const TransactionsTable: React.FC<ITable> = ({
	offset,
	setOffset,
	data,
	setNewSort,
	shouldReset,
	reset,
	length,
	limit,
	setTransactions,
	setReset,
	transactions,
	setRefundParams,
	setIsModalOpen,
    setRecord,
    setEditOpen,
    setDeleteModelOpen
}) => {

	const navigate = useNavigate();

	const { width } = useWindowDimensions();

	const [isAsc, setIsAsc] = useState({startTime: false, endTime: false, energy: false, revenue: false});
	const [isDesc, setIsDesc] = useState({startTime: false, endTime: false, energy: false, revenue: false});
	
	const {columns, rows} = computeRowsAndColsForTeamPage(data,
		navigate,
		(value) => setNewSort(value),
		shouldReset,
		reset,
		isAsc,
		isDesc,
		(value) => setIsAsc(value),
		(value) => setIsDesc(value), 
		(value) => setTransactions(value),
		(value) => setReset(value),
		transactions,
		(value) => setRefundParams(value),
		(value) => setIsModalOpen(value),
        (value) => setRecord(value),
        (value) => setEditOpen(value),
        (value) => setDeleteModelOpen(value)
	);

	return (
		<Table columns={columns} dataSource={rows} size={width > 1600 ? 'large' : (width > 1200 ? 'middle' : 'small')}
			scroll={{ x: 500 }}
			pagination={{
				total: length,
				current: offset + 1,
				onChange: (page) => setOffset(page - 1),
				defaultPageSize: Number(limit),
				showSizeChanger: false
			}}
			bordered/>
	);
};

export default TransactionsTable;
